<template>
    <CustomPage key-id="product_card" />
</template>

<script>
import CustomPage from '@@/website/pages/_.vue'
import { GET_META } from '@@/graphQL/web'

export default {
  name: 'ProductPage',

  components: {
    CustomPage
  },

  layout: 'custom',

  data: () => ({
    metaBySlug: {
      title: 'title',
      description: '',
      alt: '',
      ogTitle: '',
      ogDescription: '',
      ogImage: '',
      ogUrl: '',
    }
  }),

  apollo: {
    metaBySlug: {
      query: GET_META,
      variables () {
        return {
          route: 'product',
          siteCode: this.$store.state.siteCode,
          slug: this.$route.params.slug
        }
      }
    }
  },

  head () {
    return {
      title: this.metaBySlug?.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.metaBySlug?.description,
        },
        {
          property: 'og:title',
          content: this.metaBySlug?.ogTitle,
        },
        {
          property: 'og:description',
          content: this.metaBySlug?.ogDescription,
        },
        {
          property: 'og:image',
          content: this.metaBySlug?.ogImage,
        },
        {
          property: 'og:url',
          content: this.metaBySlug?.ogUrl,
        },
        {
          property: 'og:type',
          content: 'product',
        },
      ]
    }
  }
}
</script>
